import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5f25865e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style1 from "./Index.vue?vue&type=style&index=1&id=5f25865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25865e",
  null
  
)

export default component.exports